import config from "config"

const IMAGE_TYPES = {
  BRAND: "BRAND",
  BACKGROUND: "BACKGROUND",
  FOOTER: "FOOTER",
}

const getToken = () => (sessionStorage.getItem("token") || localStorage.getItem("token")) || sessionStorage.getItem("token")
const normalizeCompanyId = (companyId) => {
  if (companyId === null || companyId === undefined) return ""
  return String(companyId).trim()
}

const parseError = async (response) => {
  const contentType = response.headers.get("content-type") || ""

  if (contentType.includes("application/json")) {
    const payload = await response.json().catch(() => null)
    return payload?.message || payload?.error || `Error ${response.status} al subir imagen`
  }

  const text = await response.text().catch(() => "")
  return text || `Error ${response.status} al subir imagen`
}

async function uploadImage(type, file, companyId) {
  const normalizedCompanyId = normalizeCompanyId(companyId)
  if (!normalizedCompanyId) {
    return null
  }

  const formData = new FormData()
  formData.append("file", file)

  const token = getToken()
  const headers = {
    accept: "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }

  const response = await fetch(
    `${config.api.baseURL}/images/${encodeURIComponent(type)}/${encodeURIComponent(normalizedCompanyId)}`,
    {
      method: "POST",
      headers,
      body: formData,
    }
  )

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  const contentType = response.headers.get("content-type") || ""
  if (contentType.includes("application/json")) {
    return response.json()
  }

  return null
}

async function fetchImageBase64(type, companyId) {
  const normalizedCompanyId = normalizeCompanyId(companyId)
  if (!normalizedCompanyId) {
    return null
  }

  const token = getToken()
  const headers = {
    accept: "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }

  const response = await fetch(
    `${config.api.baseURL}/images/${encodeURIComponent(type)}/${encodeURIComponent(normalizedCompanyId)}/base64`,
    {
      method: "GET",
      headers,
    }
  )

  if (response.status === 204 || response.status === 404) {
    return null
  }

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  const contentType = response.headers.get("content-type") || ""
  if (contentType.includes("application/json")) {
    return response.json()
  }

  const text = await response.text().catch(() => "")
  return text || null
}

async function resetImages(companyId) {
  const normalizedCompanyId = normalizeCompanyId(companyId)
  if (!normalizedCompanyId) {
    return null
  }

  const token = getToken()
  const headers = {
    accept: "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }

  const response = await fetch(
    `${config.api.baseURL}/images/reset/${encodeURIComponent(normalizedCompanyId)}`,
    {
      method: "POST",
      headers,
    }
  )

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  const contentType = response.headers.get("content-type") || ""
  if (contentType.includes("application/json")) {
    return response.json()
  }

  return null
}

export { uploadImage, fetchImageBase64, resetImages, IMAGE_TYPES }
